"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _constants = require("../constants");

/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @class InMeetingActions
 */
var InMeetingActions = /*#__PURE__*/function () {
  function InMeetingActions() {
    (0, _classCallCheck2.default)(this, InMeetingActions);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    this.canLock = null;
    this.canUnlock = null;
    this.canAssignHost = null;
  }

  (0, _createClass2.default)(InMeetingActions, [{
    key: "setCanLock",
    value: function setCanLock(lock) {
      this.canLock = lock;
    }
  }, {
    key: "setCanUnlock",
    value: function setCanUnlock(unlock) {
      this.canUnlock = unlock;
    }
  }, {
    key: "setCanAssignHost",
    value: function setCanAssignHost(host) {
      this.canAssignHost = host;
    }
  }, {
    key: "getCanLock",
    value: function getCanLock() {
      return this.canLock;
    }
  }, {
    key: "getCanUnlock",
    value: function getCanUnlock() {
      return this.canUnlock;
    }
  }, {
    key: "getCanAssignHost",
    value: function getCanAssignHost() {
      return this.canAssignHost;
    }
  }]);
  return InMeetingActions;
}();

exports.default = InMeetingActions;
//# sourceMappingURL=in-meeting-actions.js.map
